export enum UsersGridColumns {
    Blocked = 'blocked',
    Username = 'username',
    Role = 'role',
    Email = 'email',
    CreatorUsername = 'creatorUsername',
    CreatedAt = 'createdAt',
    RegistrationToken = 'registrationToken',
    Actions = 'actions'
}
